export enum BookingTypeEnum {
	HEALTH = 'saude',
	TELEHEALTH = 'teleconsulta',
	ODONTO = 'odonto',
	EXAM = 'exame',
	SURGERY = 'cirurgia',
}
